var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "dialog" } }, [
    _c("div", { staticClass: "lbs-dialog-container", style: _vm.style }, [
      _c(
        "div",
        { staticClass: "lbs-dialog-header" },
        [
          _vm._t("header", [_c("h2", [_vm._v(_vm._s(_vm.title))])]),
          _vm._v(" "),
          _c("button", {
            staticClass: "lbs-dialog-close-button",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lbs-dialog-body" },
        [
          _vm._t("body", [
            _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lbs-dialog-footer" },
        [
          _vm._t("footer", [
            _vm._v("\n        default footer\n        "),
            _c(
              "button",
              {
                staticClass: "lbs-button",
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_vm._v("\n          OK\n        ")]
            )
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/components/vue/lbs-dialog.vue?vue&type=template&id=4285953b&
// module id = 344
// module chunks = 0